import { Component, Input, ViewChild } from '@angular/core';
import { LobI } from 'src/app/interfaces/lob.interface';
import { PermissionI, UserI } from 'src/app/interfaces/user.interface';
import { UsersService } from '../../services/users/users.service';
import { DialogComponent } from '../dialog/dialog.component';

interface Item {
  id: string | undefined;
  lob: string | undefined;
  check: boolean;
  selected: boolean;
  indeterminate: boolean;
  permissions: PermissionI[];
}

@Component({
  selector: 'app-select-permissions',
  templateUrl: './select-permissions.component.html',
  styleUrls: ['./select-permissions.component.css'],
})
export class SelectPermissionsComponent {
  user!: UserI;
  @Input() permissions: PermissionI[] = [];
  @Input() lobs: LobI[] = [];

  disabled = true;
  private permissionsEditForm: {
    permissions: Map<string, boolean | undefined>;
    groups: Map<string | undefined, { check: boolean; indeterminate: boolean; selected: boolean }>;
  } | null = null;

  userPermissions: PermissionI[] = [];
  lobsDelUsuario!: any;

  permissionsByLob: Item[] = [];

  constructor(private readonly userService: UsersService) { }
  toggleAccordion(i: Item): void {
  i.selected = !i.selected;

  if (!this.disabled) {
    this.toggleParent(!i.check, i);
  }
}
  getPermissions(userData: UserI) {

    this.user = userData;

    const userLobs = this.lobs.filter(l =>
      this.user.lob?.some(userLob => userLob.id === l.id)
    );

    // 🔥 Eliminar la condición para reconstruir siempre que cambie el usuario
    this.permissionsByLob = userLobs.map((l) => {
      return {
        id: l.id,
        lob: l.name,
        check: false,
        indeterminate: false,
        selected: false,
        permissions: this.permissions.filter((p) =>
          p.lob.some((pl) => pl.id === l.id)
        ),
      };
    });

    // Agregar permisos sin LOB a un apartado "Otros"
    const otrosPermisos = this.permissions.filter((p) => !p.lob || p.lob.length === 0);

    if (otrosPermisos.length > 0) {
      this.permissionsByLob.push({
        id: 'otros',
        lob: 'Otros',
        check: false,
        indeterminate: false,
        selected: false,
        permissions: otrosPermisos,
      });
    }

    // Revisar qué permisos están asignados
    this.permissionsByLob.forEach((l) => {
      l.permissions.forEach((p) => {
        p.check = this.user.permission?.some((uP) => uP.id === p.id);
      });

      l.check = l.permissions.every((p) => p.check === true);
      l.indeterminate = l.check ? false : l.permissions.some((p) => p.check === true);
    });

    this.userPermissions = this.user.permission!;
    this.lobsDelUsuario = this.filtrarLobsPorUsuario(this.user.lob, this.lobs);
  }



  filtrarLobsPorUsuario(userLobs: any, allLobs: any) {
    // Filtrar los LOBs que coincidan con los LOBs del usuario
    return allLobs.filter((lob: any) =>
      userLobs.some((userLob: any) => userLob.id === lob.id)
    );
  }

  returnListByType(id: string) {
    return id
      ? this.permissions.filter((p) => {
        return p.lob.some((l) => l.id == id);
      })
      : this.permissions.filter((p) => {
        return p.lob.length === 0;
      });
  }

  // Maneja el cambio del checkbox principal
  toggleParent(check: boolean, i: Item) {
    i.check = check;
    i.permissions.map((j) => (j.check = check));
    const everyFalse = i.permissions.every((i: any) => i.check == false);
    i.indeterminate = everyFalse ? !everyFalse : i.indeterminate;
  }

  // Maneja el cambio de los hijos
  toggleChild(i: Item) {
    const every = i.permissions.every((i) => i.check == true);
    const everyFalse = i.permissions.every((i) => i.check == false);
    i.indeterminate = everyFalse ? !everyFalse : !every;
    i.check = every;
  }

  startEditing() {
    this.permissionsEditForm = {
      permissions: new Map(
        this.permissionsByLob
          .flatMap((group) => group.permissions)
          .map((permission) => [permission.id, permission.check])
      ),
      groups: new Map(
        this.permissionsByLob.map((group) => [group.id, {
          check: group.check,
          indeterminate: group.indeterminate,
          selected: group.selected,
        }])
      ),
    };
    this.disabled = false;
  }

  cancelAction() {
    if (this.permissionsEditForm) {
      this.permissionsByLob.forEach((group) => {
        group.permissions.forEach((permission) => {
          permission.check = this.permissionsEditForm!.permissions.get(permission.id);
        });

        const groupSnapshot = this.permissionsEditForm!.groups.get(group.id);
        if (groupSnapshot) {
          group.check = groupSnapshot.check;
          group.indeterminate = groupSnapshot.indeterminate;
          group.selected = groupSnapshot.selected;
        }
      });
      this.permissionsEditForm = null;
    }

    this.disabled = true;
  }

  /** @description Instancia del dialog component */
  @ViewChild('dialog') dialog!: DialogComponent;

  /** @description Agregamos los permisos al usuario */
  addPermissions() {
    this.dialog.confirm(
      '¿Esta seguro de agregar los siguientes permisos?',
      'Confirmación de carga',
      () => {
        this.dialog.start();

        const userPermissions = this.permissionsByLob
          .flatMap((l) => l.permissions)
          .filter((p) => p.check);
        //.map(({ id }) => ({ id }));

        const user: Partial<UserI> = {
          id: this.user.id,
          permission: userPermissions as any,
        };
        this.userService.update(user).subscribe({
          next: (data) => {
            this.dialog.stop(
              'Los permisos se agregaron correctamente',
              'Confirmación de carga',
              () => {
                this.user.permission = data.result?.permissions || [];
                this.disabled = true;
                this.permissionsEditForm = null;
              }
            );
          },
          error: (e) => {
            console.error(e);
            this.dialog.stop(
              'Ocurrió un error al intentar agregar los permisos.',
              'Error de carga',
              () => { },
              false
            );
          },
        });
      }
    );
  }
}
